export default class AIProofreaderSubmittedDocument {
  private readonly _continueUrl: string;
  private readonly _words: number;
  private readonly _checkMetaReport: boolean;
  private readonly _previewEnabled: boolean;
  private readonly _filename: string;
  private readonly _docLanguage: string;
  private readonly _name: string;

  constructor({
    attributes,
    links,
  }) {
    this._continueUrl = links.continue;
    this._words = attributes.words;
    this._checkMetaReport = attributes.checkMetaReport;
    this._previewEnabled = attributes.previewEnabled;
    this._filename = attributes.filename;
    this._docLanguage = attributes.language;
    this._name = attributes.name;
  }

  get continueUrl(): string {
    return this._continueUrl;
  }

  get words(): number {
    return this._words;
  }

  get checkMetaReport(): boolean {
    return this._checkMetaReport;
  }

  get previewEnabled(): boolean {
    return this._previewEnabled;
  }

  get filename(): string {
    return this._filename;
  }

  get docLanguage(): string {
    return this._docLanguage;
  }

  get name(): string {
    return this._name;
  }
}
